import { useEffect, useState } from "react";
import { mutar } from "../lib/useApi";
import { Button, Input } from "./ui";

// «Mi contraseña» (C-14 = ampliación A-11, tramo 07 de huayruro-orden-y-mapa, aprobada por Kevin para los 4
// roles): cada persona cambia la suya. `PATCH /auth/password` existía sin ninguna pantalla; hasta hoy solo
// otra persona (Usuarios) podía cambiarla. Pide la actual: un celular olvidado con la sesión abierta no
// basta para cambiarla.
export function MiContrasenaModal({ onCerrar, onListo }: { onCerrar: () => void; onListo: () => void }) {
  const [actual, setActual] = useState("");
  const [nueva, setNueva] = useState("");
  const [repetida, setRepetida] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const esc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCerrar();
    };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onCerrar]);

  async function guardar() {
    if (nueva.length < 8) {
      setError("La nueva necesita 8 caracteres o más.");
      return;
    }
    if (nueva !== repetida) {
      setError("La nueva y la repetida no son iguales.");
      return;
    }
    setEnviando(true);
    setError(null);
    try {
      await mutar("/auth/password", { method: "PATCH", body: { actual, nueva } });
      onListo();
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
      setEnviando(false);
    }
  }

  const campo = (id: string, etiqueta: string, valor: string, cambiar: (v: string) => void, autoFocus = false) => (
    <label htmlFor={id} className="mt-3 block">
      <span className="mb-1 block text-[13px] text-ink-2">{etiqueta}</span>
      <Input id={id} type="password" value={valor} onChange={(e) => cambiar(e.target.value)} autoFocus={autoFocus} autoComplete={id === "clave-actual" ? "current-password" : "new-password"} />
    </label>
  );

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-ink-surface/40 p-4 backdrop-blur" onClick={onCerrar}>
      <div
        role="dialog"
        aria-label="Mi contraseña"
        className="w-full max-w-md rounded-[14px] border border-line bg-card p-6 shadow-[0_10px_30px_rgba(36,29,26,0.25)]"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-[16.5px] font-bold text-ink">Mi contraseña</h2>
        <p className="mt-1 text-[13px] text-ink-2">Cámbiala tú. Te pedimos la actual para confirmar que eres tú.</p>
        {campo("clave-actual", "Contraseña actual", actual, setActual, true)}
        {campo("clave-nueva", "Nueva (8 caracteres o más)", nueva, setNueva)}
        {campo("clave-repetida", "Repite la nueva", repetida, setRepetida)}
        {error && <p className="mt-2 text-[12.5px] text-accent-ink">{error}</p>}
        <div className="mt-5 flex gap-2">
          <Button variant="outline" onClick={onCerrar} disabled={enviando} className="min-h-[44px] flex-1 justify-center">
            Cancelar
          </Button>
          <Button onClick={() => void guardar()} disabled={enviando || !actual || !nueva || !repetida} className="min-h-[44px] flex-1 justify-center">
            {enviando ? "Guardando…" : "Guardar"}
          </Button>
        </div>
      </div>
    </div>
  );
}
